import axios from "axios";
import appConfig from "configs/app.config";
import { REQUEST_HEADER_AUTH_KEY } from "constants/api.constant";
import { PERSIST_STORE_NAME } from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";
import store from "../store";
import { onSignOutSuccess } from "../store/auth/sessionSlice";
import { setUser, initialState } from "../store/auth/userSlice";
import { Notification, toast } from "components/ui";

const unauthorizedCode = [401];

const showErrorToast = (message) => {
  toast.push(
    <Notification type="danger" closable>
      {message}
    </Notification>,
  );
};

const isNgrokEndpoint = /ngrok/i.test(appConfig.apiBaseUrl);

const BaseService = axios.create({
  timeout: 60000,
  baseURL: appConfig.apiBaseUrl,
});

BaseService.interceptors.request.use(
  (config) => {
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);

    const accessToken = persistData?.auth?.session?.token;
    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${accessToken}`;
    }

    // Without this ngrok serves its HTML interstitial, which carries no CORS
    // headers and surfaces in the browser as a CORS failure on every call.
    if (isNgrokEndpoint) {
      config.headers["ngrok-skip-browser-warning"] = "true";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    const status = response?.status;
    const state = store.getState();
    const hadSession = Boolean(
      state.auth.session.signedIn && state.auth.session.token,
    );

    if (response && unauthorizedCode.includes(status)) {
      store.dispatch(onSignOutSuccess());
      store.dispatch(setUser(initialState));

      if (hadSession) {
        window.location.replace(appConfig.unAuthenticatedEntryPath);
        return Promise.reject(error);
      }
    }

    const message =
      error?.response?.data?.message || "Something went wrong";
    showErrorToast(message);

    return Promise.reject(error);
  },
);

export default BaseService;
